import React, { useState, useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { ciaCameraNameInfo } from "../../service/CIA/CiaService";
import { Loading } from "../../components/Loading/Loading";
import ValidateService from "../../components/ValidateService/ValidateService";
import { dataUserSession } from "../../utilities/dataSession";
import { Toast } from "primereact/toast";

export default function PCIADialog(props) {

    const onHide = () => {
        handlerCloseDialog();

    };

    const handlerCloseDialog = () => {
        props.setDialog({ open: false });
    };

    const iframeRef = useRef(null);
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [searchData] = useState({

        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const toast = useRef(null);


   
 




    return (
        <>
        <Loading loading={loading} />
        <ValidateService err={errData} setErr={setErrData} />
            <Dialog
                header="ข้อมูลกล้องจากระบบ CIA"
                visible={props.dialog.open}
                style={{ width: "90vw" }}
                //  footer={renderFooter()} 
                onHide={() => onHide()}
                blockScroll={true}
                className="p-fluid"
                maximizable={true}>

                <div className="p-fluid p-formgrid p-grid">
                    {/* <button 
                    // onclick="javascrip t:history.back( )"
                    >BACK</button>
                    <button 
                    // onclick="window.history.forward()"
                    >FORWARD</button>*/}
                    <p>Camera Name : {props.dataSet.cameraName}</p> 


                    <iframe
                        ref={iframeRef}
                      src={props.dataSet.cameraUrl}
                        width="100%" height="800px">

                        </iframe>
                </div>

            </Dialog>
        </>
    )

}